import React from 'react'
import { useTranslation } from 'react-i18next'
import { Close } from '@mui/icons-material'
import { makeStyles } from 'tss-react/mui'
import { IconButton } from '@mui/material'

const useStyles = makeStyles()(() => ({
  deleteLabel: {
    width: '32px',
    height: '32px',
    fontSize: '12px',
    letterSpacing: '0.4px',
    lineHeight: '14px',
    flexDirection: 'column',
  },
}))

const CloseIconButton: React.FC<{ onClick?: () => void }> = ({ onClick }) => {
  const { t } = useTranslation()
  const { classes } = useStyles()

  return (
    <IconButton
      color="primary"
      onClick={onClick}
      classes={{
        root: classes.deleteLabel,
      }}
      size="large"
    >
      <Close />
      {t('削除')}
    </IconButton>
  )
}

export default CloseIconButton
